import {create} from 'zustand';
import {persist} from "zustand/middleware";
import {createDebouncedJSONStorage} from "zustand-debounce";
import indexedDbStorage from "../utils/indexeddb-zustand-store";
import {LegendStore} from "../types/legend";

export const storageName = 'MOOD_legend_store';

const useLegendStore = create<LegendStore>()(
  persist(
    (set) => ({
      legend: null,
      setLegend: (legend) => set({legend: legend}),

      showSurfaceMap: true,
      setShowSurfaceMap: (state) => set({showSurfaceMap: state}),

      showGlobalShapeFile: true,
      setShowGlobalShapeFile: (state) => set({showGlobalShapeFile: state}),

      showMesh: true,
      setShowMesh: (state) => set({showMesh: state}),

      visibleUploads: [],
      setVisibleUploads: (uploads) => set({visibleUploads: uploads}),

      uploadedFeatures: [],
      setUploadedFeatures: (features) => set({uploadedFeatures: features}),

      uploadingShapefile: false,
      setUploadingShapefile: (state) => set({uploadingShapefile: state}),

      showDatasetZones: false,
      setShowDatasetZones: (state) => set({showDatasetZones: state}),

      showLabelLayer: true,
      setShowLabelLayer: (state) => set({showLabelLayer: state}),

      uploadedShapefile: [],
      setUploadedShapefile: (shapefile) => set({uploadedShapefile: shapefile}),

      showInSituPoints: false,
      setShowInSituPoints: (state) => set({showInSituPoints: state}),

      showFWEPoints: false,
      setShowFWEPoints: (state) => set({showFWEPoints: state}),

      showUploadedShapefile: false,
      setShowUploadedShapefile: (state) => set({showUploadedShapefile: state}),

      showLayerView: false,
      setShowLayerView: (state) => set({showLayerView: state}),

      reset: () => set({
        legend: null,
        showSurfaceMap: true,
        showGlobalShapeFile: true,
        showMesh: true,
        visibleUploads: [],
        uploadedFeatures: [],
        uploadingShapefile: false,
        showDatasetZones: false,
        showLabelLayer: true,
        uploadedShapefile: [],
        showInSituPoints: false,
        showFWEPoints: false,
        showUploadedShapefile: false,
        showLayerView: false,
      })
    }),
    {
      name: storageName,
      storage: createDebouncedJSONStorage(indexedDbStorage, {debounceTime: 500}),
      version: 1,
      partialize: (state) => ({
        legend: state.legend,
        showSurfaceMap: state.showSurfaceMap,
        showGlobalShapeFile: state.showGlobalShapeFile,
        showMesh: state.showMesh,
        visibleUploads: state.visibleUploads,
        uploadedFeatures: state.uploadedFeatures,
        showDatasetZones: state.showDatasetZones,
        showLabelLayer: state.showLabelLayer,
        uploadedShapefile: state.uploadedShapefile,
        showInSituPoints: state.showInSituPoints,
        showFWEPoints: state.showFWEPoints,
        showUploadedShapefile: state.showUploadedShapefile,
        showLayerView: state.showLayerView,
      })
    }
  )
);

export const isStoreEmpty = (state: LegendStore) => {
  return state.legend === null &&
    state.visibleUploads.length === 0 &&
    state.uploadedFeatures.length === 0 &&
    state.uploadedShapefile.length === 0;
};

export default useLegendStore;
